import {useEffect, useState} from 'react'
import { Link, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import api from '../../api/api';
import { useAppDispatch } from '../../store/store';
import { logout, setLoading } from '../../store/slice/utilSlice';
import { FaAngleDown, FaGlobe, FaInfoCircle, FaLock, FaPlus, FaSearch } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { toast } from 'react-toastify';
import { FaAngleRight } from 'react-icons/fa6';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next'
import { useProfileStore } from '../../store/useUserStore';

const Profile = () => {
    const [parentData, setParentData] = useState({
        name:"",
        email: "",
        ic: "",
        birthday: "",
        profilePic:"/assets/img/default-profile.jpg",
        phone: ""
    })
    const dispatch = useAppDispatch()
    const [students, setStudents] = useState([])
    const navigate = useNavigate()
    const [expandChangePassword, setExpandChangePassword] = useState(false)
    const [expandChangeLanguage, setExpandChangeLanguage] = useState(false)
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const { t } = useTranslation()
    const {profile} = useProfileStore((state) => state)

    useEffect(() => {
        if (profile) {
            getStudents()
            setParentData({
                name: profile.name || "",
                email: profile.email || "",
                ic: profile.ic_number || "",
                birthday: profile.birthday || "",
                profilePic: profile.profile_pic || "/assets/img/default-profile.jpg",
                phone: profile.phone || ""
            })
        }
    }, [profile])
    
    function getStudents() {
        dispatch(setLoading(true))
        api.get(`${process.env.REACT_APP_API_BASE_URL}/student`).then( res => {
            console.log("res student", res.data.result.data)
            setStudents( res.data.result.data)
        }).catch( err => {
            console.log("err", err)
        }).finally(() => {
            dispatch(setLoading(false))
        })
    }

    function handleLogout() {
        if (window.confirm(t('are_you_sure_log_out'))) {
            dispatch(logout())
            window.location.reload()
        }
    }

    function handleChangePassword() {
        if (newPassword !== confirmPassword) return toast.error("Password not match")

        dispatch(setLoading(true))
        api.post(`${process.env.PUBLIC_URL}/user/change-password`, {
            "password": newPassword,
            "confirm_password": confirmPassword
        }).then(res => {
            setExpandChangePassword(false)
            setNewPassword("")
            setConfirmPassword("")
            dispatch(setLoading(false))
            toast.success("Succesfully changed password")
        }).catch(err =>{
            console.log("err", err)
            dispatch(setLoading(false))
            toast.error("Server Error")
        })
    }



    return (
        <div className="pb-28 text-black">
            <div className="mb-10">
                <div className="flex flex-col items-center text-center">
                    <div className="w-24 h-24 mb-4">
                        <img src={parentData.profilePic} alt="" className="w-full h-full rounded-full object-cover" />
                    </div>
                    <h3 className="text-lg font-bold mb-2">{parentData.name}</h3>
                    <div className="w-full">
                        <div className="text-sm font-normal text-gray-700 mb-1">{parentData.ic}</div>
                    </div>
                </div>
            </div>

            <div className="profile-body-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="profile-body">
                                <div className="profile-info-table space-mb--40 border-2">
                                    <div className="profile-info-block">
                                        <div className="profile-info-block__title">{t('profile.name')}</div>
                                        <div className="profile-info-block__value">{parentData.name}</div>
                                    </div>
                                    <div className="profile-info-block">
                                        <div className="profile-info-block__title">{t('profile.ic')}</div>
                                        <div className="profile-info-block__value">{parentData.ic}</div>
                                    </div>
                                    <div className="profile-info-block">
                                        <div className="profile-info-block__title">{t('profile.phone')}</div>
                                        <div className="profile-info-block__value">{parentData.phone || "-"}</div>
                                    </div>
                                    <div className="profile-info-block">
                                        <div className="profile-info-block__title">{t('profile.email')}</div>
                                        <div className="profile-info-block__value">{parentData.email}</div>
                                    </div>
                                    <div className="profile-info-block">
                                        <div className="profile-info-block__title">{t('profile.birthday')}</div>
                                        <div className="profile-info-block__value">{parentData.birthday}</div>
                                    </div>
                                    <div className="profile-info-block">
                                        <div className="profile-info-block__title">{t('profile.edit_profile')}</div>
                                        <div className="profile-info-block__value">
                                            <Link to={"/profile/edit"}>
                                                <ReactSVG src={"/assets/img/icons/edit.svg"} />
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className='text-lg font-medium mb-2'>{t('profile.manage_child')}</div>
                                <div className="rounded-lg bg-white  mb-8">
                                    {students.map((student:any, index:any) => (
                                        <div className="flex items-center border-b-2 p-3" onClick={() => navigate(`/children/edit/${student.id}`)} key={index}>
                                            <div className="w-10 h-10 mr-4">
                                                <img src={student.profile_pic || "/assets/img/default-profile.jpg"} alt="" className="w-full h-full rounded-full object-cover" />
                                            </div>
                                            <div className="text-sm font-medium flex-1">{student.name}</div>
                                            <FaAngleRight/>
                                        </div>
                                    ))}
                                    <div className="flex items-center border-b-2 p-3" onClick={() => { navigate("/children/add") }}>
                                        <div className="text-sm font-medium flex-1">{t('profile.add_child')}</div>
                                        <FaPlus/>
                                    </div>
                                </div>

                                <div className="p-3 border-2 mb-6 border-gray-300 rounded-xl">
                                    <div className="grid grid-cols-10 items-center" onClick={() => { navigate("/payment-history") }}>
                                        <FaSearch className='mr-2 col-span-1 justify-self-center'/>
                                        <div className="col-span-8 font-semibold">{t('profile.payment_history')}</div>
                                    </div>
                                </div>

                                <div className="p-3 border-2 mb-6 border-gray-300 rounded-xl">
                                    <div className="grid grid-cols-10 items-center">
                                        <FaLock className='mr-2 col-span-1 justify-self-center'/>
                                        <div className="col-span-8 font-semibold">{t('profile.change_password')}</div>
                                        {expandChangePassword ? (
                                            <FaAngleDown className='col-span-1 justify-self-center' onClick={() => { setExpandChangePassword(!expandChangePassword) }} />
                                        ) : (
                                            <FaAngleRight className='col-span-1 justify-self-center' onClick={() => { setExpandChangePassword(!expandChangePassword) }} />
                                        )}
                                    </div>
                                    {expandChangePassword && (
                                        <div className="mt-4">
                                            <div className="mb-3 mx-3">
                                                <label className=" text-md font-medium mb-2">{t('profile.new_password')}</label>
                                                <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="w-full px-4 py-2 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme" />
                                            </div>
                                            <div className="mb-3 mx-3">
                                                <label className=" text-md font-medium mb-2">{t('profile.confirm_new_password')}</label>
                                                <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full px-4 py-2 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme" />
                                            </div>
                                            <button onClick={() => { handleChangePassword() }} type="button" className="justify-self-center text-white font-semibold text-[16px] leading-none w-1/2 py-[15px] bg-black border-none rounded-3xl flex items-center justify-center">
                                                {t('profile.update')}
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="p-3 border-2 mb-6 border-gray-300 rounded-xl" >
                                    <div className="grid grid-cols-10 items-center" >
                                        <FaGlobe className='mr-2 col-span-1 justify-self-center'/>
                                        <div className="col-span-8 font-semibold">{t('profile.change_language')}</div>
                                        {expandChangeLanguage ? (
                                            <FaAngleDown className='col-span-1 justify-self-center' onClick={()=>{setExpandChangeLanguage(!expandChangeLanguage)}}/>
                                        ):(
                                            <FaAngleRight className='col-span-1 justify-self-center' onClick={()=>{setExpandChangeLanguage(!expandChangeLanguage)}}/>
                                        )}
                                    </div>
                                    {expandChangeLanguage && (
                                        <div className="mt-4">
                                            <div className="mb-3 ml-4" onClick={(e) => { i18next.changeLanguage("en") }}>
                                                <div className="text-md font-medium">English</div>
                                            </div> 
                                            <div className="mb-3 ml-4" onClick={(e) => { i18next.changeLanguage("zh") }}>
                                                <div className="text-md font-medium">Mandarin</div>
                                            </div>
                                            <div className="mb-3 ml-4" onClick={(e) => { i18next.changeLanguage("ms") }}>
                                                <div className="text-md font-medium">Bahasa Malaysia</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                
                                <a href="https://forms.gle/9Ts6GhTrNxxa6KYN8" target="_blank" rel="noopener noreferrer" className="block p-3 bg-[#fecc1a] mb-6 rounded-xl hover:text-black active:text-black focus:text-black" >
                                    <div className="grid grid-cols-10 items-center">
                                        <FaInfoCircle className='mr-2 col-span-1 justify-self-center'/>
                                        <div className="col-span-8 font-semibold">{t('profile.help_centre')}</div>
                                    </div>
                                </a>


                                <div className="flex justify-center">
                                    <div className="rounded-lg bg-danger w-1/2">
                                        <div className="flex items-center px-6 py-3 text-white border-0">
                                            <FiLogOut size={16} />
                                            <div className="flex-1 font-medium text-sm text-center cursor-pointer" onClick={() => handleLogout()}>{t('profile.logout')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Profile;
